import { itemLightBox } from '@/api/schema';
import { eventBus } from '@/main';

export function imageClickHandler(
  items: itemLightBox[],
  index: number = 0
): void {
  eventBus.$emit('setLightBoxItems', items, index);
}
